import { Box, Divider, Stack, Typography } from '@mui/material';
import { green, red, yellow } from '@mui/material/colors';
import { useSelector } from "react-redux";
import Flag from './Flag';



export default function EmployeeTJLDisplay({ lifestyleStatus, tjlStyle }) {
    const { appLanguage, resourceFinal } = useSelector((state) => state.settings.resource.resources);

    return (
        <Box sx={{ mt: 1 }}>
            <Divider>
                <Typography variant="body1">{resourceFinal[appLanguage].messages.TJL_STATUS_EMPLOYEE}</Typography>
            </Divider>
            <Stack direction="row" spacing={1} justifyContent="center">
                <Flag
                    count={lifestyleStatus}
                    style={{ color: lifestyleStatus === 2 ? green[500] : lifestyleStatus === 1 ? yellow[700] : red[500] }}
                    icon={tjlStyle}
                />
                <Typography variant="body1">
                    {lifestyleStatus === 2 ? resourceFinal[appLanguage].messages.TJL_COMPLETED_EMPLOYEE :
                        lifestyleStatus === 1 ? resourceFinal[appLanguage].messages.TJL_STARTED_EMPLOYEE :
                            resourceFinal[appLanguage].messages.TJL_NOT_STARTED_EMPLOYEE}
                </Typography>
            </Stack>
        </Box>
    );
}
